import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { Logo } from '../components/Logo';

/**
 * Page d'onboarding - Redirige automatiquement vers le dashboard
 * Cette page s'affiche brièvement après la création d'un compte
 */
export default function OnboardingPage() {
  const navigate = useNavigate();
  const { user } = useAuth();

  useEffect(() => {
    // Rediriger immédiatement vers le dashboard
    const timer = setTimeout(() => {
      if (user?.is_admin) {
        navigate('/dashboard');
      } else {
        navigate('/catalog');
      }
    }, 1000);

    return () => clearTimeout(timer);
  }, [user, navigate]);

  return (
    <div className="min-h-screen bg-gradient-to-br from-[#F9FAFB] to-[#E5F3F0] flex items-center justify-center p-6">
      <div className="max-w-md w-full">
        {/* Logo OrderLab en haut */}
        <div className="flex justify-center mb-8">
          <Logo size="large" showText={true} />
        </div>

        {/* Message de bienvenue */}
        <div className="bg-white rounded-2xl shadow-lg border border-gray-100 p-8 text-center">
          <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
            <svg className="w-8 h-8 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
            </svg>
          </div>
          
          <h1 className="text-2xl font-bold text-gray-900 mb-2">
            Bienvenue sur OrderLab ! 🎉
          </h1>
          
          <p className="text-gray-600 mb-6">
            Votre compte a été créé avec succès. Vous allez être redirigé vers votre espace...
          </p>

          <div className="flex justify-center">
            <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-[#1B4332]"></div>
          </div>
        </div>

        {/* Footer */}
        <p className="text-center text-gray-500 text-sm mt-6">
          © 2024 OrderLab — Tous droits réservés
        </p>
      </div>
    </div>
  );
}
